<p-confirmDialog key="classattendance" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div *ngIf="showAttendance">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-content">
					<div class="panel panel-default">
						<div class="panel-heading">
							<div class="panel-title">
								<strong>Classroom Attendance</strong>
								<div style="text-align: end; font-size: 15px">
									<button type="button" class="btn btn-danger" (click)="removeTodayattendance()">X</button>
								</div>
							</div>
						</div>

						<div class="panel-body">
							<div *ngIf="isLoading" class="alert alert-warning box-msg" role="alert">
								<strong>Loading. Please wait...</strong>
							</div>

							<div *ngIf="!isLoading">
								<div *ngIf="PleaseSubmitMessage && isLoading == false" class="alert alert-info box-msg" role="alert">
									<strong>Class attendance not yet taken - Please Submit.</strong>
								</div>

								<div *ngIf="AlreadySavedMessage && isLoading == false" class="alert alert-info box-msg" role="alert">
									<strong>Class attendance taken before - Submit not required.</strong>
								</div>

								<div *ngIf="hideSharedLinkCopyMessage" class="alert alert-success box-msg" role="alert">
									<strong>Attendance Saved!</strong>
								</div>

								<button type="button" class="btn btn-primary" (click)="onSubmitClick()" (mouseover)="onhover(5)" (mouseout)="nohover(5)">
									Submit
								</button>

								<span *ngIf="submitAll" style="color: chocolate">Press Submit to save today's attendace !</span>
								<input
									type="text"
									name="getText"
									placeholder="Click here before scan"
									[(ngModel)]="scanID"
									(change)="studentScanned($event.target.value)"
								/>

								<div *ngIf="saving" class="warning box-msg" role="warning">Processing. Please wait...</div>
								<br />
								<input
									type="checkbox"
									name="all"
									[(ngModel)]="selectedAll"
									(change)="selectAll()"
									(mouseover)="onhover(1)"
									(mouseout)="nohover(1)"
								/>

								<button
									type="button"
									class="btn btn-primary"
									(click)="oncheckedSubmitClick(1)"
									(mouseover)="onhover(2)"
									(mouseout)="nohover(2)"
								>
									P
								</button>
								<span>&nbsp;</span>
								<button
									type="button"
									class="btn btn-primary"
									(click)="oncheckedSubmitClick(2)"
									(mouseover)="onhover(3)"
									(mouseout)="nohover(3)"
								>
									A
								</button>
								<span>&nbsp;</span>
								<button
									type="button"
									class="btn btn-primary"
									(click)="oncheckedSubmitClick(5)"
									(mouseover)="onhover(4)"
									(mouseout)="nohover(4)"
								>
									T
								</button>
								<span>&nbsp;</span>
								<button type="button" class="btn btn-primary" (click)="onAddPointsAllClick()" (mouseover)="onhover(7)" (mouseout)="nohover(7)">
									Add Points
								</button>
								<span>&nbsp;</span>

								<span *ngIf="checkboxAllShow" style="color: chocolate">Check the box to select all students</span>
								<span *ngIf="presentAll" style="color: chocolate">After selectAll checkbox, press P to mark all present!</span>
								<span *ngIf="absentAll" style="color: chocolate">After selectAll checkbox , press A to mark all absent!</span>
								<span *ngIf="tardyAll" style="color: chocolate">After selectAll checkbox, press T to all mark tardy!</span>
								<span *ngIf="pbisAll" style="color: chocolate">Press the checkboxes to select which students to add a point to!</span>

								<div *ngIf="showButton && isLoading == false">
									<div *ngIf="erroMessage" class="alert alert-danger box-msg" role="alert">
										{{ erroMessage }}
									</div>
								</div>
							</div>

							<div *ngIf="ShowGroupAddPoints">
								<caass-classroom-classroomAttendance-Group-Point-AddPoints
									[SchoolID]="SchoolID"
									[AddProcessing]="AddProcessing"
									(onAddGroupPoints)="AddGroupPoints($event)"
									(onCancelGroupPoints)="CancelGroupPoints()"
								>
								</caass-classroom-classroomAttendance-Group-Point-AddPoints>
							</div>

							<div *ngIf="isLoading == false">
								<table class="table table-striped table-hover" my-table options="options" width="100%">
									<tr *ngFor="let student of studentList">
										<td>
											<input
												type="checkbox"
												name="studentList"
												value="{{ student.PersonID }}"
												[(ngModel)]="student.selected"
												(change)="onCheckboxChange(student.PersonID, $event)"
											/>
										</td>
										<td>
											<img
												alt="image"
												[src]="student.PersonPhotoUrl"
												class="img-circle m-t-xs img-responsive"
												width="72"
												height="72"
												(click)="pullStudentInfo($event, student.PersonID)"
											/>
											<br />
											<div *ngIf="showStudentInfo && SelectedPersonID == student.PersonID">
												<table
													style="
														float: left;
														width: 258px;
														margin: 0 0 7px 14px;
														border-collapse: collapse;
														background: rgb(196, 243, 255);
														border: 1px solid #999;
														line-height: 1.5;
														color: black;
														font-size: smaller;
													"
												>
													<tr>
														<th
															colspan="2"
															style="
																background: #ddd;
																border-bottom: 1px solid #999;
																font-size: larger;
																padding: 4px;
																text-align: center;
															"
														>
															Student's Detail
															<button
																style="float: right"
																(click)="offStudentInfo()"
																(mouseover)="onhover(6)"
																(mouseout)="nohover(6)"
																[ngStyle]="{
																	'background-color': closeButtonColor
																}"
															>
																X
															</button>
														</th>
													</tr>

													<tr style="border-bottom: 1px solid #999">
														<td style="padding: 4px">
															<b>StudentID:</b>
														</td>
														<td style="padding: 4px">
															{{ studentInfoList.StudentID }}
														</td>
													</tr>
													<tr style="border-bottom: 1px solid #999">
														<td style="padding: 4px">
															<b>School Attendance:</b>
														</td>
														<td style="padding: 4px">
															{{ studentInfoList.SchoolAttendanceStatus }}
														</td>
													</tr>
													<tr style="border-bottom: 1px solid #999">
														<td style="padding: 4px">
															<b>Class Attendance:</b>
														</td>
														<td style="padding: 4px">
															{{ studentInfoList.ClassAttendanceStatusDesc }}
														</td>
													</tr>
													<tr style="border-bottom: 1px solid #999">
														<td style="padding: 4px">
															<b>Class Entry Time:</b>
														</td>
														<td style="padding: 4px">
															{{ studentInfoList.EntryTime | date : "HH:mm:ss" }}
														</td>
													</tr>
												</table>
											</div>
										</td>
										<td>
											<b>
												{{ student.FirstName }}
												{{ student.LastName }}</b
											>
											<br (onPointChange)="changeBalancePoint($event)" />
											({{ student.PointsBalance }} Points)
										</td>

										<td>
											<div>
												<span style="display: inline-block; width: 55px"></span>
												<button
													type="button"
													class="btn"
													(click)="setpColor($event, student.PersonID)"
													id="pButton"
													[ngStyle]="{
														'background-color': student.pbuttonColor
													}"
												>
													P
												</button>
												<span style="display: inline-block; width: 8px"></span>
												<button
													type="button"
													class="btn"
													(click)="setpColor($event, student.PersonID)"
													id="aButton"
													[ngStyle]="{
														'background-color': student.abuttonColor
													}"
												>
													A
												</button>
												<span style="display: inline-block; width: 8px"></span>
												<button
													type="button"
													class="btn"
													(click)="setpColor($event, student.PersonID)"
													id="tButton"
													[ngStyle]="{
														'background-color': student.tbuttonColor
													}"
												>
													T
												</button>

												<span style="display: inline-block; width: 8px"></span>

												<button
													type="button"
													class="btn btn-primary"
													(click)="IncidentbtnClick($event, student.PersonID)"
													href="javascript:void(0);"
												>
													Incident
												</button>

												<span style="display: inline-block; width: 8px"></span>

												<!--TODO FIX DROPDOWN-->
												<button class="btn btn-primary" (click)="onDropdownOpen(student)">
													Point

													<i *ngIf="student.ShowPointsOptions == false" class="fa fa-caret-down" aria-hidden="true"></i>
													<i *ngIf="student.ShowPointsOptions == true" class="fa fa-caret-up" aria-hidden="true"></i>
												</button>
												<div class="dropdown-content" *ngIf="student.ShowPointsOptions == true">
													<div class="dropdown-button-list">
														<button class="btn btn-primary" (click)="addPoints($event, student.PersonID)">Add Points</button>
														<button class="btn btn-success" (click)="redeemPoints($event, student.PersonID)">Redeem Points</button>
														<button class="btn btn-danger" (click)="voidTransaction($event, student.PersonID)">
															Void Transaction
														</button>
													</div>
												</div>
											</div>
											<div *ngIf="incidentC && SelectedPersonID == student.PersonID">
												<caass-classroom-classroomAttendance-Incident
													[personid]="student.PersonID"
													[schoolid]="student.SchoolID"
												></caass-classroom-classroomAttendance-Incident>
											</div>

											<div *ngIf="addPointC && SelectedPersonID == student.PersonID">
												<caass-classroom-classroomAttendance-Point-AddPoints
													[balancePoint]="student.PointsBalance"
													[schoolID]="student.SchoolID"
													[personid]="student.PersonID"
													(onPointChange)="changeBalancePoint($event)"
												></caass-classroom-classroomAttendance-Point-AddPoints>
											</div>

											<div *ngIf="redeemPointC && SelectedPersonID == student.PersonID">
												<caass-classroom-classroomAttendance-Point-RedeemPoints
													[balancePoint]="student.PointsBalance"
													[schoolID]="student.SchoolID"
													[personid]="student.PersonID"
												></caass-classroom-classroomAttendance-Point-RedeemPoints>
											</div>

											<div *ngIf="voidTransactionC && SelectedPersonID == student.PersonID">
												<caass-classroom-classroomAttendance-Point-VoidTransaction
													[personid]="student.PersonID"
													[schoolID]="student.SchoolID"
												></caass-classroom-classroomAttendance-Point-VoidTransaction>
											</div>
										</td>
									</tr>
								</table>
								<button type="button" class="btn btn-primary" (click)="onSubmitClick()" (mouseover)="onhover(5)" (mouseout)="nohover(5)">
									Submit
								</button>
								<span *ngIf="submitAll" style="color: chocolate">Press Submit to save today's attendance !</span>
								<div *ngIf="saving" class="warning box-msg" role="warning">Processing. Please wait...</div>
								<div *ngIf="hideSharedLinkCopyMessage" class="alert alert-success box-msg" role="alert">
									<strong>Attendance Saved!</strong>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="closeAttendance">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-content">
					<div class="panel panel-default">
						<div class="panel-heading">
							<h3 class="panel-title">
								<strong>Classroom Attendance History</strong>
							</h3>
						</div>

						<div class="panel-body">
							<div style="text-align: end; font-size: 10px">
								<button type="button" class="btn btn-danger" (click)="removePastRecord()">Close</button>
							</div>
							<h5>*Note:This past record is read only !</h5>

							<br />

							<div *ngIf="loadingPastRecord" class="alert alert-warning box-msg" role="alert">
								<strong>Loading Record, Please wait..!</strong>
							</div>

							<table class="table table-striped table-hover" *ngIf="isLoading == false" my-table options="options" width="100%">
								<tr *ngFor="let student of studentList">
									<td>
										<img
											alt="image"
											[src]="student.PersonPhotoUrl"
											class="img-circle m-t-xs img-responsive"
											width="72"
											height="72"
											(click)="pullStudentInfo($event, student.PersonID)"
										/>
										<br />
										<div *ngIf="showStudentInfo && SelectedPersonID == student.PersonID">
											<table
												style="
													float: left;
													width: 258px;
													margin: 0 0 7px 14px;
													border-collapse: collapse;
													background: rgb(196, 243, 255);
													border: 1px solid #999;
													line-height: 1.5;
													color: black;
													font-size: smaller;
												"
											>
												<tr>
													<th
														colspan="2"
														style="
															background: #ddd;
															border-bottom: 1px solid #999;
															font-size: larger;
															padding: 4px;
															text-align: center;
														"
													>
														Student's Detail
														<button
															style="float: right"
															(click)="offStudentInfo()"
															(mouseover)="onhover(6)"
															(mouseout)="nohover(6)"
															[ngStyle]="{
																'background-color': closeButtonColor
															}"
														>
															X
														</button>
													</th>
												</tr>

												<tr style="border-bottom: 1px solid #999">
													<td style="padding: 4px">
														<b>StudentID:</b>
													</td>
													<td style="padding: 4px">
														{{ studentInfoList.PersonID }}
													</td>
												</tr>
												<tr style="border-bottom: 1px solid #999">
													<td style="padding: 4px">
														<b>School Attendance:</b>
													</td>
													<td style="padding: 4px">
														{{ studentInfoList.SchoolAttendanceStatus }}
													</td>
												</tr>
												<tr style="border-bottom: 1px solid #999">
													<td style="padding: 4px">
														<b>Class Attendance:</b>
													</td>
													<td style="padding: 4px">
														{{ studentInfoList.ClassAttendanceStatusDesc }}
													</td>
												</tr>
												<tr style="border-bottom: 1px solid #999">
													<td style="padding: 4px">
														<b>Class Entry Time:</b>
													</td>
													<td style="padding: 4px">
														{{ studentInfoList.EntryTime | date : "HH:mm:ss" }}
													</td>
												</tr>
											</table>
										</div>
									</td>
									<td>
										<b>
											{{ student.FirstName }}
											{{ student.LastName }}</b
										>
									</td>

									<td>
										<div>
											<span style="display: inline-block; width: 55px"></span>
											<button
												type="button"
												class="btn"
												id="pButton"
												[ngStyle]="{
													'background-color': student.pbuttonColor
												}"
											>
												P
											</button>
											<span style="display: inline-block; width: 8px"></span>
											<button
												type="button"
												class="btn"
												id="aButton"
												[ngStyle]="{
													'background-color': student.abuttonColor
												}"
											>
												A
											</button>
											<span style="display: inline-block; width: 8px"></span>
											<button
												type="button"
												class="btn"
												id="tButton"
												[ngStyle]="{
													'background-color': student.tbuttonColor
												}"
											>
												T
											</button>

											<span style="display: inline-block; width: 8px"></span>
											<button
												type="button"
												class="btn btn-primary"
												(click)="IncidentbtnClick($event, student.PersonID)"
												href="javascript:void(0);"
											>
												Incident
											</button>

											<span style="display: inline-block; width: 8px"></span>
											<span class="dropdown" dropdown [dropdownToggle]="false">
												<button class="btn btn-primary" dropdown-open>
													Point
													<span class="caret"></span>
												</button>

												<ul class="dropdown-menu">
													<li>
														<a (click)="addPoints($event, student.PersonID)">Add Points</a>
													</li>
													<li>
														<a (click)="redeemPoints($event, student.PersonID)">Redeem Points</a>
													</li>
													<li>
														<a (click)="voidTransaction($event, student.PersonID)">Void Transaction</a>
													</li>
												</ul>
											</span>
										</div>
										<div *ngIf="incidentC && SelectedPersonID == student.PersonID">
											<caass-classroom-classroomAttendance-Incident
												[personid]="student.PersonID"
												[schoolid]="student.SchoolID"
											></caass-classroom-classroomAttendance-Incident>
										</div>

										<div *ngIf="addPointC && SelectedPersonID == student.PersonID">
											<caass-classroom-classroomAttendance-Point-AddPoints
												[balancePoint]="student.PointsBalance"
												[schoolID]="student.SchoolID"
												[personid]="student.PersonID"
												(onPointChange)="changeBalancePoint($event)"
											></caass-classroom-classroomAttendance-Point-AddPoints>
										</div>

										<div *ngIf="redeemPointC && SelectedPersonID == student.PersonID">
											<caass-classroom-classroomAttendance-Point-RedeemPoints
												[balancePoint]="student.PointsBalance"
												[schoolID]="student.SchoolID"
												[personid]="student.PersonID"
											></caass-classroom-classroomAttendance-Point-RedeemPoints>
										</div>

										<div *ngIf="voidTransactionC && SelectedPersonID == student.PersonID">
											<caass-classroom-classroomAttendance-Point-VoidTransaction
												[personid]="student.PersonID"
												[schoolID]="student.SchoolID"
											></caass-classroom-classroomAttendance-Point-VoidTransaction>
										</div>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
